var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-card',{staticClass:"pa-0",attrs:{"tile":""}},[_c('v-sheet',{staticClass:"overflow-y-auto pa-0",attrs:{"id":"sheet1"}},[_c('mainmenu')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }